module.exports = __webpack_public_path__ + "img/auth-google.e37b79b3.svg";